import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PayCircleFilledSvg from "@ant-design/icons-svg/es/asn/PayCircleFilled";
import AntdIcon from "../components/AntdIcon";
var PayCircleFilled = function PayCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PayCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PayCircleFilled.displayName = 'PayCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(PayCircleFilled);